import styled from "styled-components";
import { Link } from "react-router-dom";
import { black } from "../../global/colours";
import { weight as fontWeight } from "../../global/fonts";

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-bottom: 40px;
`;

export const StyledListItem = styled.li`
  font-size: 10px;
  font-weight: 400!important;
`;

const BaseLinkStyles = `
  color: ${black[100]};
  text-decoration: none;
  display: inline-block;
  margin-bottom: 4px;
  text-transform: uppercase;

  &:hover {
    text-decoration: underline!important;
    text-decoration-color: ${black[100]}!important;
  }
`;

export const ListLink = styled(Link)`
  ${BaseLinkStyles}
`;

export const ExternalLink = styled.a`
  ${BaseLinkStyles}
`;
